import {take, takeLeading, call} from "redux-saga/effects";
import type {Dispatch} from "redux";
import type {SagaIterator} from "redux-saga";
import log from "@atg-shared/log";
import {subscribe} from "@atg-frame-shared/push";
import * as PushActions from "@atg-frame-shared/push-saga/domain/pushActions";
import * as UserActions from "@atg-global-shared/user/userActionTypes";
import {USER_ENTERED_TILLSAMMANS} from "@atg-tillsammans/app-data-access/redux";
import {
    CHAT_ACTIVE_USERS,
    CHAT_MESSAGE_CREATE,
    CHAT_MESSAGE_DELETE,
    CHAT_MESSAGE_PIN,
    CHAT_MESSAGE_UPDATE,
    type ChatPushAction,
} from "@atg-tillsammans/team-chat-types";

import * as ChatActions from "./teamChatActions";

export const getChatMessageCallback =
    (dispatch: Dispatch<any>) => (action: ChatPushAction) => {
        log.debug("getChatMessageCallback", {type: "chat", action});

        switch (action.actionType) {
            case CHAT_MESSAGE_CREATE:
                dispatch(ChatActions.addMessage(action.comment));
                break;
            case CHAT_MESSAGE_UPDATE:
                dispatch(ChatActions.changeMessageText(action.comment));
                break;
            case CHAT_MESSAGE_DELETE:
                dispatch(ChatActions.deleteMessage(action.comment.id));
                break;
            case CHAT_MESSAGE_PIN:
                dispatch(ChatActions.pinOrUnpinMessage(action.comment));
                break;
            case CHAT_ACTIVE_USERS:
                // TODO: Handle active users count if needed
                break;
            default:
                break;
        }
    };

export function* subscribeToChat(dispatch: Dispatch<any>): SagaIterator<void> {
    const messageCallback = yield call(getChatMessageCallback, dispatch);
    const topic = "chat/>";
    const unsubscribe = yield call(subscribe, topic, messageCallback, false, true);
    const reconnectAction = yield take([
        UserActions.LOGOUT_INITIATED,
        PushActions.RECONNECTED,
    ]);

    yield call(unsubscribe);

    if (reconnectAction.type === PushActions.RECONNECTED) {
        yield call(subscribeToChat, dispatch);
    }
}

export default function* chatListenerSaga(dispatch: Dispatch<any>) {
    yield takeLeading(
        [UserActions.LOGIN_FINISHED, UserActions.RECEIVE_USER, USER_ENTERED_TILLSAMMANS],
        subscribeToChat,
        dispatch,
    );
}
